var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m8.82609 40c4.32221 0 7.82611-3.7097 7.82611-8.2857 0-4.5761-3.5039-8.2857-7.82611-8.2857-4.32223 0-7.82609 3.7096-7.82609 8.2857 0 4.576 3.50386 8.2857 7.82609 8.2857z",
  stroke: "#c5cad1",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m38.174 40c4.3222 0 7.8261-3.7097 7.8261-8.2857 0-4.5761-3.5039-8.2857-7.8261-8.2857s-7.8261 3.7096-7.8261 8.2857c0 4.576 3.5039 8.2857 7.8261 8.2857z",
  stroke: "#c5cad1",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m21.5434 31.7142 11.7391-12.4285h-16.6304",
  stroke: "#ffd200",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m16.5 19.5-8 12.5h13",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m38.174 31.7143-1.7609-.6215-4.5-18.0214 6.2609.8286c.9782.2071 1.7608 1.2428 1.5652 2.2786-.1957 1.0357-1.1739 1.8642-2.1522 1.6571",
  stroke: "#c5cad1",
  strokeMiterlimit: 10
})), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m21.5 32-7.0785-19.7095",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m11.7609 11 5.8695 2.0714",
  stroke: "#ffd200",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));
function SvgSports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.90a14094.svg";
export { ForwardRef as ReactComponent };